import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getDeviceTargetingTags(targetUsers: TargetingBaseType['targetUsers']): TagItem[] {
  if (!targetUsers?.enabled) {
    return [];
  }
  const mode = targetUsers.options?.type === 'exclude' ? 'Exclude mode' : 'Include mode';

  return [{ label: mode }];
}
